import api from '../lib/axios';
export async function getUsers(params) {
    const { data } = await api.get('/api/superadmin/users', { params });
    return data;
}
export async function createUser(body) {
    const { data } = await api.post('/api/superadmin/users', body);
    return data.data;
}
export async function updateUser(id, body) {
    const { data } = await api.patch(`/api/superadmin/users/${id}`, body);
    return data.data;
}
export async function deleteUser(id) {
    await api.delete(`/api/superadmin/users/${id}`);
}
export async function resendUserInvitation(id) {
    await api.post(`/api/superadmin/users/${id}/resend-invitation`);
}
